import { Component } from "react";
import { Switch } from "@platform/ui-library";
import Button from "../form_components/Button";
import Exporter from "../utilities/Exporter";
import AppValidation from "../utilities/AppValidation";
import { ReactDOMComponents } from "../utilities/ReactDOMComponents";
import { Constant } from '../const';

const NON_COLLAB = Constant.k.NON_COLLAB;

export class ExportWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validateOnExport: false
    };
    this.reactDOMComponents = new ReactDOMComponents();
    this.closeValidationDialog = this.closeValidationDialog.bind(this);
    this.handleCommonModuleExport = this.handleCommonModuleExport.bind(this);
    this.handleValidateCheckbox = this.handleValidateCheckbox.bind(this);
  }

  getToggleValidateCheckbox() {
    return (
      <Switch
        checked={this.state.validateOnExport}
        inputFirst
        label="Validate on Export"
        onChange={this.handleValidateCheckbox}
      />
    );
  }

  /**
   * validateOnExport toggles validation popup on export
   */
  handleValidateCheckbox() {
    this.setState({ validateOnExport: !this.state.validateOnExport });
  }

  closeValidationDialog() {
    this.setState({ isSaving: false });
    this.reactDOMComponents.unmountComponentAtNode($(".validator_container"));
    w2popup.close();
  }

  async handleCommonModuleExport() {
    await Exporter.exportDesignerFile(window.apm.serialized);
  }

  render() {
    return (
      <div>
        <h4>Actions</h4>

        <div className="flex-gap-wrap" style={{ justifyContent: 'space-between', textAlign: 'center' }}>
          <span>
            <label>Export Designer JSON</label>
            <Button labelIcon="layout" label="Designer JSON" wide={true} callback={this.handleCommonModuleExport} />
          </span>
          <span>
            <label>Export Engine JSON</label>
            <Button
              labelIcon="folder"
              label="Engine JSON"
              wide={true}
              callback={async () => {
                const exportEngineFile = async () => {
                  await Exporter.exportEngineFile(window.apm.serialized);
                };
                if (this.state.validateOnExport || NON_COLLAB) {
                  window.apm.popup(
                    window.l.popup.validator_results,
                    '<div class="validator_container"></div>',
                    [
                      '<button class="w2ui-btn secondary">',
                      `  ${window.l.popup.close}`,
                      '</button> ',
                      '<button class="w2ui-btn primary add-button">',
                      `  ${window.l.popup.export}`,
                      '</button>'
                    ].join(''),
                    [
                      '.validator_container',

                      () => {
                        const errors = AppValidation.applicationValidation(window.apm.serialized);

                        const $el = $('.validator_container');
                        this.reactDOMComponents.renderDialog({
                          name: 'validatorDialog',
                          props: {
                            closeDialog: this.closeValidationDialog,
                            errors: errors
                          },
                          $el
                        });

                        $('.w2ui-popup')
                          .find('.add-button')
                          .on('click', async () => {
                            this.reactDOMComponents.unmountComponentAtNode($('.validator_container'));
                            w2popup.close();
                            await exportEngineFile();
                          });
                        $('.w2ui-popup')
                          .find('.secondary')
                          .on('click', () => {
                            this.reactDOMComponents.unmountComponentAtNode($('.validator_container'));
                            w2popup.close();
                          });
                      }
                    ],
                    700, // height
                    null, // node
                    null, // treenode
                    false // showClose
                  );
                } else {
                  // TODO: Freezes UI in large apps (Citi)
                  // Utility.openApplicationOverlay('Downloading Export Files');
                  await exportEngineFile();
                  // Utility.closeApplicationOverlay()
                }
              }}
            />
            {!NON_COLLAB && this.getToggleValidateCheckbox()}
          </span>
          {this.props.children}
        </div>
      </div>
    );
  }
}
